'use client';
import { makeStyles } from "@fluentui/react-components";
export const useCheckboxStyles = makeStyles({
    root: {
        display: 'flex'
    }
});
